'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.useValidation = void 0;

var react_1 = require('react');

var useValidation = function useValidation(_a) {
  var _b = _a.validationRules,
    validationRules = _b === void 0 ? [] : _b,
    error = _a.error,
    forceError = _a.forceError,
    _c = _a.defaultValidatedStatus,
    defaultValidatedStatus = _c === void 0 ? false : _c;

  var _d = react_1.useState(undefined),
    validationRule = _d[0],
    setValidationRule = _d[1];

  var _e = react_1.useState(defaultValidatedStatus),
    validatedStatus = _e[0],
    setValidatedStatus = _e[1];

  var validate = function validate(value) {
    setValidationRule(
      validationRules.find(function (rule) {
        return !rule.validate(value);
      })
    );
  };

  var validateoOnChange = function validateoOnChange(value) {
    if (value === void 0) {
      value = '';
    }

    if (validatedStatus || forceError) {
      validate(value);
    }
  };

  var validateOnBlur = function validateOnBlur(value) {
    if (value === void 0) {
      value = '';
    }

    setValidatedStatus(true);
    validate(value);
  };

  return {
    error: error || (validationRule && validationRule.error),
    validateoOnChange: validateoOnChange,
    validateOnBlur: validateOnBlur,
  };
};

exports.useValidation = useValidation;
